import { render, staticRenderFns } from "./manage-study.vue?vue&type=template&id=676bb7b2&scoped=true&"
import script from "./manage-study.vue?vue&type=script&lang=ts&"
export * from "./manage-study.vue?vue&type=script&lang=ts&"
import style0 from "./manage-study.vue?vue&type=style&index=0&id=676bb7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bb7b2",
  null
  
)

export default component.exports